import { Mapper } from "../../../../base/utils/mapper";
import { UnitsTimeModel } from "../../../../domain/models/consult/units-time.model";
import { UnitsTimeEntity } from "../entities/units-time.entity";


export class UnitsTimeImplementationRepositoryMapper extends Mapper<UnitsTimeEntity, UnitsTimeModel> {
    mapFrom(param: UnitsTimeEntity): UnitsTimeModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: UnitsTimeModel): UnitsTimeEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}